import { forwardRef, type Ref, type SVGProps } from "react";
const IconCheckmarkCircleOutlineSVG = (
  { children, ...rest }: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    viewBox="0 0 32 32"
    ref={ref}
    {...rest}
  >
    {children}
    <path
      fill="currentColor"
      d="M16 4A12 12 0 1 1 4 16 12 12 0 0 1 16 4m0-2a14 14 0 1 0 14 14A14 14 0 0 0 16 2"
    />
    <path
      fill="currentColor"
      d="M22.7 10.1a1 1 0 0 0-1.4 0l-8.3 9-2.8-3a1 1 0 0 0-1.4 0 1 1 0 0 0 0 1.4l3.5 3.9a1 1 0 0 0 1.4 0l9-9.8a1 1 0 0 0 0-1.5"
    />
  </svg>
);
const ForwardRef = forwardRef(IconCheckmarkCircleOutlineSVG);
ForwardRef.displayName = "IconCheckmarkCircleOutline";
export { ForwardRef as IconCheckmarkCircleOutline };
